module.exports = __webpack_public_path__ + "media/images/190630-CMN-Nestle-5275c-2-60ab5b01.jpg";